import { createSlice } from "@reduxjs/toolkit";
import { readFromLocalStorage, saveToLocalStorage } from "utils/helper";

// define state here
const initialState = {
  data: [],
  totalRecords: 0,
  isFetching: false,
  error: null,
};

export const accessControlSlice = createSlice({
  name: "accessControlData",
  initialState,
  reducers: {
    fetchDataBegin: (state) => {
      state.isFetching = true;
      state.error = null;
    },
    fetchDataError: (state, action) => {
      const { message = null } = action.payload;
      state.isFetching = false;
      state.error = message;
    },

    getAccessControlSuccess: (state, action) => {
      const { newData } = action.payload;
      state.isFetching = false;
      state.data = newData;
      state.totalRecords = newData.length;
      // saveToLocalStorage("accessControlData", newData);
    },
  },
});

export const { fetchDataBegin, fetchDataError, getAccessControlSuccess } =
  accessControlSlice.actions;

export const accessControlDataSelector = (state) =>
  state.accessControlData.data;

export default accessControlSlice.reducer;
